// 这里链的都是report的
import createCustomAxios from '../utils/axios';
const http = createCustomAxios(process.env.VUE_APP_BASE_API);
// 导航接口
export function getLeftNav(params) {
	return http({
		method: 'get',
		url: '/WebChannelCommonController/getAllSonMenus',
		params,
	});
}
//文章列表接口
export function getDocsByUids(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getDocsByUids',
		params,
	});
}
//文献列表页热点专题
export function getTopicListByUid(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getTopicListByUid',
		params,
	});
}
// 获取首页统计数据
export function getIndexStatistics() {
	return http({
		method: 'get',
		url: '/WebChannelCommonController/getAllSonMenus?uid=A103',
	})
}

// 首页报告库
export function getReportList() {
	return http({
		method: 'get',
		url: '/indexController/getAllReports?curpage=1&pagesize=3',
	})
}

/**
 * 新增：课程思政案例页面获取案例文档列表
 */
export function getCaseDocsByUids(params) {
  return http({
    url: '/DocCommonController/getCaseDocsByUids', // 根据实际后端路径调整
    method: 'get', 
    params: params // 如果是 GET 请求用 params，POST 请求通常用 data
  })
}
